import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import NotFound from "../components/not-found"
import SEO from "../components/seo"

const NotFoundPage = () => {
  const [shouldRenderFallback, setShouldRenderFallback] = useState(false)

  useEffect(() => {
    const currentPath = window.location.pathname

    // Log the path for debug if needed
    console.debug("404 caught path:", currentPath)

    if (currentPath.startsWith("/event-submission")) {
      navigate("/page/event-submission", { replace: true })
    } else if (currentPath !== "/404") {
      navigate("/", { replace: true })
    } else {
      // If we're actually on /404 itself with no meaningful redirect target
      setShouldRenderFallback(true)
    }
  }, [])

  return (
    <>
      <SEO title="404 - Not found" />
      {shouldRenderFallback && (
        <NotFound
          topLine="/404 - NOT FOUND"
          middleLine="Missing page or digital art installation? You decide."
          bottomLine="In the meantime we hope you can find what you’re looking for:"
        />
      )}
    </>
  )
}

export default NotFoundPage